import { withSnackbar, WithSnackbar } from "components/SnackbarProvider/Snackbar";
import { FeedItemDto } from "models/ApiModels";
import * as React from "react";
import { GetPublicationResultMessage } from "views/Publication/Components/GetPublicationResultMessage";
import { publicationFactory } from "views/Timeline/Components/FeedHelpers";

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    data: FeedItemDto;
    onClose: (update: boolean) => void;
}

/////////////////////////////////////////////////////////////////////////////////////

const Edit: React.FC<IProps & WithSnackbar> = (props) => {
    const { data: { publicationId, publicationType }, onClose } = props;

    var dialog = publicationFactory(
        publicationId,
        publicationType,
        (saveResult) => {
            var r = GetPublicationResultMessage(saveResult);
            if (r.message) props.snackbar.showMessage(r.message, r.messageOption);
            onClose(saveResult != null);
        }
    );

    return dialog;
};

export default withSnackbar(Edit);